{
  "maximum": "最大",
  "minimum": "最小"
}
